package music.limasoul.shared.network.domain.model

import kotlinx.serialization.Serializable

@Serializable
class ErrorWrapper(val error: Error) {

    @Serializable
    class Error(val status: Int, val message: String)
}